export default axiosInstance => {
  async function create({ jwt, reservation }) {
    return (
      await axiosInstance({
        method: "post",
        url: "/liff/vipReservation",
        headers: {
          jwt
        },
        data: { reservation }
      })
    ).data;
  }

  return {
    create
  };
};
